function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "m 0.52321168,12.559144 a 2,2 0 0 1 -1.99999998,2 2,2 0 0 1 -2,-2 2,2 0 0 1 2,-2 h 1.99999998 v 2 m 1.00000002,0 a 2,2 0 0 1 2,-2 2,2 0 0 1 2,2 v 5 a 2,2 0 0 1 -2,2 2,2 0 0 1 -2,-2 v -5 m 2,-8.0000016 a 2,2 0 0 1 -2,-2 2,2 0 0 1 2,-2.00000001 2,2 0 0 1 2,2.00000001 v 2 h -2 m 0,1 a 2,2 0 0 1 2,2 2,2 0 0 1 -2,2 h -5 a 2,2 0 0 1 -2,-2 2,2 0 0 1 2,-2 h 5 m 8.0000003,2 a 2,2 0 0 1 2,-2 2,2 0 0 1 2,2 2,2 0 0 1 -2,2 h -2 v -2 m -1,0 a 2,2 0 0 1 -2.0000003,2 2,2 0 0 1 -2,-2 v -5 a 2,2 0 0 1 2,-2.00000001 2,2 0 0 1 2.0000003,2.00000001 v 5 M 8.5232117,15.559144 a 2,2 0 0 1 2.0000003,2 2,2 0 0 1 -2.0000003,2 2,2 0 0 1 -2,-2 v -2 h 2 m 0,-1 a 2,2 0 0 1 -2,-2 2,2 0 0 1 2,-2 h 5.0000003 a 2,2 0 0 1 2,2 2,2 0 0 1 -2,2 z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-4 0 20 20"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/slack.980dc9e6.svg";
export { SvgComponent as ReactComponent };